import { deepmerge } from '@mui/utils';
const LineHeights = {
    h1: '56px',
    h2: '48px',
    h3: '40px',
    h4: '32px',
    h5: '28px',
    h6: '24px',
    body1: '24px',
    body2: '20px',
    subtitle1: '24px',
    subtitle2: '20px',
    caption: '20px',
};
const FontSize = {
    h1: '3rem', // 48px
    h2: '2.5rem', // 40px
    h3: '2rem', // 32px
    h4: '1.625rem', // 26px
    h5: '1.25rem', // 20px
    h6: '1.125rem', // 18px
};
export const ThemeTypography = {
    fontFamily: 'MB Corpo S Text',
    fontFamilyCorpoSTitle: ['MB Corpo S Title'].join(',') /* MB CORPO S TITLE >> Light: 300, Regular: 400, Bold: 700 */,
    fontFamilyCorpoSText: ['MB Corpo S Text'].join(',') /* MB CORPO S TEXT >> Light: 300, Regular: 400, Bold: 700 */,
    fontFamilyCorpoSTitleCondensed: ['MB Corpo S Title Condensed'].join(',') /* MB CORPO S TITLE CONDENSED >> Light: 300, Regular: 400, Bold: 700 */,
    fontFamilyCorpoSTextCondensed: ['MB Corpo S Text Condensed'].join(',') /* MB CORPO S TEXT CONDENSED >> Light: 300, Regular: 400, Bold: 700 */,
    fontFamilyCorpoATitle: ['MB Corpo A Title', 'MB Corpo S Title'].join(',') /* MB CORPO A TITLE >> Regular: 400 */,
    fontFamilyCorpoATitleCondensed: ['MB Corpo A Title Condensed', 'MB Corpo S Title Condensed'].join(',') /* MB CORPO A TITLE CONDENSED >> Regular: 400 */,
    fontFamilyCorpoATextCondensed: ['MB Corpo A Text Condensed', 'MB Corpo S Text Condensed'].join(',') /* MB CORPO A TEXT CONDENSED >> Regular: 400 */,
    fontFamilyCorpoAScreen1Condensed: ['MB Corpo A Screen 1 Condensed'].join(',') /* MB CORPO A SCREEN 1 CONDENSED >> Regular: 400 */,
    fontFamilyCorpoAScreen2Condensed: ['MB Corpo A Screen 2 Condensed'].join(',') /* MB CORPO A SCREEN 2 CONDENSED >> Regular: 400 */,
};
export const ThemeTypographyOptions = {
    fontFamily: ThemeTypography.fontFamilyCorpoSText,
    fontSize: 14,
    fontWeightMedium: 'bolder',
    h1: {
        fontSize: FontSize.h1,
        fontWeight: 400,
        marginBottom: 20,
        fontFamily: ThemeTypography.fontFamilyCorpoATextCondensed,
        lineHeight: LineHeights.h1,
        letterSpacing: 0,
    },
    h2: {
        fontSize: FontSize.h2,
        fontFamily: ThemeTypography.fontFamilyCorpoATextCondensed,
        lineHeight: LineHeights.h2,
        letterSpacing: 0,
    },
    h3: {
        fontSize: FontSize.h3,
        fontFamily: ThemeTypography.fontFamilyCorpoSTitleCondensed,
        lineHeight: LineHeights.h3,
        letterSpacing: 0,
    },
    h4: {
        fontSize: FontSize.h4,
        fontFamily: ThemeTypography.fontFamilyCorpoSTitleCondensed,
        lineHeight: LineHeights.h4,
        letterSpacing: 0,
    },
    h5: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        fontSize: FontSize.h5,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: LineHeights.h5,
    },
    h6: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        fontSize: FontSize.h6,
        fontWeight: 700,
        letterSpacing: 0,
        lineHeight: LineHeights.h6,
    },
    body1: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        letterSpacing: 0,
        lineHeight: LineHeights.body1,
    },
    body2: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        lineHeight: LineHeights.body2,
    },
    subtitle1: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        lineHeight: LineHeights.subtitle1,
        fontWeight: 700,
        letterSpacing: 0,
    },
    subtitle2: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        fontWeight: 700,
        lineHeight: LineHeights.subtitle2,
    },
    caption: {
        fontFamily: ThemeTypography.fontFamilyCorpoSText,
        lineHeight: LineHeights.caption,
    },
    button: {
        fontWeight: 700,
        textTransform: 'none',
    },
};
export const AdvertismentTypographyOptions = deepmerge(ThemeTypographyOptions, {
    h1: {},
}, { clone: true });
